<template>
	<div class="libramiento puiformheader">
		<v-layout wrap>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('libramiento.mercancia')" :value="getMercancia"></pui-field>
			</v-flex>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('libramiento.terminalgestora')" :value="getTerminalgestora"></pui-field>
			</v-flex>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('libramiento.fecharecogida')" :value="getFecharecogida"></pui-field>
			</v-flex>
			<v-flex xs12 md6 v-if="false">
				<pui-field :label="this.$t('libramiento.peso')" :value="getPeso"></pui-field>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import PuiFormHeaderMixin from 'pui9-mixins/PuiFormHeaderMixin';

export default {
	name: 'libramientotermcformheader',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'libramientotermc'
		};
	},
	computed: {
		getMercancia() {
			return this.model && this.model.mercancia ? this.model.mercancia : '';
		},
		getFecharecogida() {
			return this.model && this.model.fecharecogida
				? this.$dateTimeUtils.formatDate(this.model.fecharecogida, this.$store.getters.dateFormat)
				: '';
		},
		getPeso() {
			return this.model && this.model.pesosolicitado ? this.formatNumber(this.model.pesosolicitado) : '';
		},
		getTerminalgestora() {
			return this.model && this.model.terminalgestora ? this.model.terminalgestora : '';
		}
	},
	methods: {
		extendFilter(filter) {
			filter.model = 'libramientotermc';
		},
		formatNumber(val) {
			if (val === null) {
				return '';
			}
			const thousandSeparator = this.$store.getters.thousandSeparator;
			const decimalSeparator = this.$store.getters.decimalSeparator;
			if (val.toString().includes('.')) {
				const parts = val.toString().split('.');
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
				return parts.join(decimalSeparator);
			}
			return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`);
		}
	}
};
</script>
<style lang="postcss" scoped></style>
<i18n>
{
	"en": {
		"libramiento.mercancia": "Goods",
		"libramiento.fecharecogida": "Pick up date",
		"libramiento.peso": "Number of Kg.",
		"libramiento.timeslot": "Time slot",
		"libramiento.de": "From",
		"libramiento.a": "to",
		"libramiento.terminalgestora": "Management terminal"

	},
	"es": {
		"libramiento.mercancia": "Mercancía",
		"libramiento.fecharecogida": "Fecha de recogida",
		"libramiento.peso": "Nº Kg.",
		"libramiento.timeslot": "Time slot",
		"libramiento.de": "De",
		"libramiento.a": "a",
		"libramiento.terminalgestora": "Terminal gestora"
	},
	"ca": {
		"libramiento.mercancia": "Mercaderia",
		"libramiento.fecharecogida": "Data de recollida",
		"libramiento.peso": "Num. Kg.",
		"libramiento.timeslot": "Time slot",
		"libramiento.de": "De",
		"libramiento.a": "a",
		"libramiento.terminalgestora": "Terminal gestora"
	}
}
</i18n>
